export const JAR_CONFIGURATION_DATA = 'JAR_CONFIGURATION_DATA';

export const JAR_CONFIGURATION_DATA_SUCCESSFUL = 'JAR_CONFIGURATION_DATA_SUCCESSFUL';

export const JAR_CONFIGURATION_API_ERROR = 'JAR_CONFIGURATION_API_ERROR';

export const JAR_EDIT_CONFIGURATION = 'JAR_EDIT_CONFIGURATION';

export const JAR_ADD_CONFIGURATION = 'JAR_ADD_CONFIGURATION';